import { cn } from '@/lib/utils'

/**
 * The DyeAtlas mark: a split swatch standing for a dyed sample against its
 * reference, drawn inline so it scales and themes without an asset request.
 */
export function Logo({ className, withWordmark = true }: { className?: string; withWordmark?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg viewBox="0 0 28 28" className="size-7 shrink-0" role="img" aria-label="DyeAtlas">
        <rect width="28" height="28" rx="7" fill="var(--color-paper-muted)" />
        <rect x="5" y="6" width="7" height="16" rx="2" fill="var(--color-brand)" />
        <rect x="14" y="6" width="4" height="9" rx="1.5" fill="#6f8f4a" />
        <rect x="14" y="16" width="4" height="6" rx="1.5" fill="#c9a227" />
        <rect x="20" y="6" width="3" height="16" rx="1.5" fill="var(--color-ink)" opacity="0.12" />
      </svg>
      {withWordmark && (
        <span className="font-display text-[22px] font-semibold leading-none text-brand">
          DyeAtlas
        </span>
      )}
    </span>
  )
}
